import React from "react";
import { useTranslation } from "react-i18next";
import { useUserData } from "../../../../../common/hooks/useUserData";
import NewFormField from "../../../../../common/layout/form/NewFormField";
import {
  container,
  divider,
  fieldContainer,
} from "../../../../styles/fieldsContainer.styles";


const UserFields: React.FC = () => {
  const { t } = useTranslation("admin");
  const requireEmail = true;
  const { user } = useUserData();
  return (
    <div className={container}>
      <div className={divider}>
        <div className={fieldContainer}>
          <NewFormField name="firstName" label={t("auth.formLabels.firstName") as string} />
        </div>
        <div className={fieldContainer}>
          <NewFormField name="lastName" label={t("auth.formLabels.lastName") as string} />
        </div>
      </div>
      <div className={divider}>
        <div className={fieldContainer}>
          <NewFormField value={user ? user.emails[0] : ''} required={requireEmail} disabled={!requireEmail} name="email" label={t("nav.email") as string} type="email" />
        </div>
        {/* <div className={fieldContainer}>
          <NewFormField name="phoneNumber" label={t("nav.phoneNumber") as string}/>
        </div> */}
      </div>
    </div>
  );
};

export default UserFields;